export default function auditUniqueNameDirective(
  $q,
  amDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const auditId = attributes.auditId || -1;
    ngModel.$asyncValidators.amAuditUniqueName = (modelValue) => {
      const defer = $q.defer();
      amDataService.checkAuditExists(modelValue, auditId).then((data) => {
        if (data && !data.data.result) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'amAuditUniqueName';

auditUniqueNameDirective.$inject = [
  '$q',
  'amDataService'
];
